
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import * as types from '@/store/mutation-types'
export default {
directives: {
TransferDom
},
props: ['upload', 'menu', 'title'],
data() {
return {
show: false,
showLoading: false,
refresh_token: '',
text: '正在上传中...'
}
},
computed: {
user() {
return JSON.parse(window.localStorage.user)
},
token() {
return this.$store.state.base.qiniuToken
},
live() {
return this.$store.state.live.detail
}
},
methods: {
showMenu() {
this.show = true
},
back() {
this.$router.go(-1)
},
getQiniuToken() {
return new Promise((resolve, reject) => {
this.$store
.dispatch('getQiniuToken')
.then(res => {
resolve(res)
})
.catch(err => {
reject(err)
})
})
},

initQiniu() {
let _this = this
var domain =
window.location.host == 'yun.aiyaopai.com' || window.location.host == 'yun.aiyaopai.com'
? 'https://storage-live-user.aiyaopai.com'
: 'https://storage-live-user.dev.aiyaopai.com'
var uploader = Qiniu.uploader({
runtimes: 'html5,flash,html4', // 上传模式，依次退化
browse_button: 'pickfiles', // 上传选择的点选按钮，必需
uptoken: this.token, // uptoken是上传凭证，由其他程序生成
get_new_uptoken: false, // 设置上传文件的时候是否每次都重新获取新的uptoken
domain: domain, // bucket域名，下载资源时用到，必需
container: 'container', // 上传区域DOM ID，默认是browser_button的父元素
max_file_size: '100mb', // 最大文件体积限制
flash_swf_url: 'path/of/plupload/Moxie.swf', //引入flash，相对路径
max_retries: 3, // 上传失败最大重试次数
dragdrop: true, // 开启可拖曳上传
drop_element: 'container', // 拖曳上传区域元素的ID，拖曳文件或文件夹后可触发上传
chunk_size: '4mb', // 分块上传时，每块的体积
auto_start: true, // 选择文件后自动上传，若关闭需要自己绑定事件触发上传
multi_selection: false, // 禁用多选
init: {
FilesAdded: function(up, files) {
plupload.each(files, function(file) {
// 文件添加进队列后，处理相关的事情
})
},
BeforeUpload: function(up, file) {
// 每个文件上传前，处理相关的事情
},
UploadProgress: function(up, file) {
// 每个文件上传时，处理相关的事情
_this.$vux.loading.show({
text: '正在上传中...'
})
},
FileUploaded: function(up, file, info) {
// 查看简单反馈
_this.$vux.loading.hide()
let fmt_info = eval('(' + info + ')')
if (fmt_info.success) {
let url = fmt_info.url
// 跳转到填写内容页面,将图片链接信息传递过去
_this.$router.push({
name: 'liveInteractionPublish',
params: {
pic: url
}
})
}
},
Error: function(up, err, errTip) {
//上传出错时，处理相关的事情
alert('上传图片格式错误')
},
UploadComplete: function() {
//队列文件处理完毕后，处理相关的事情
},
Key: function(up, file) {
// 若想在前端对每个文件的key进行个性化处理，可以配置该函数
// 该配置必须要在unique_names: false，save_key: false时才生效
var key = ''
// do something with key here
return key
}
}
})
// domain为七牛空间对应的域名，选择某个空间后，可通过 空间设置->基本设置->域名设置 查看获取
// uploader为一个plupload对象，继承了所有plupload的方法
}
},

components: {
TransferDom,
Popup,
Group,
Cell
},

mounted() {
// alert('头部初始化完毕')
this.getQiniuToken()
.then(res => {
this.initQiniu()
})
.catch(err => {
if (err.response.status == 401) {
// 重新授权
// console.log('需要重新授权咯', this.$route)
// window.localStorage.to = JSON.stringify(to)
let redUrl = encodeURI(window.location.origin + '/login')
let url = `https://wechatauth.aiyaopai.com/auth/clientside?appid=wx76b9a692b8709d44&redirect_uri=${redUrl}&response_type=code&scope=snsapi_userinfo&state=21`
window.location.href = url
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/XHeader/XHeader.vue